import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss';

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
           <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            contentArrowStyle={{ borderRight: '7px solid white' }}
            date="2025 - Present"
            iconStyle={{ background: '#5000ca', color: 'white' }}
            icon={<FontAwesomeIcon icon={faLaptopCode} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">STULZ Mumbai, IN</h4>
            <p>
              Software Development with MEAN Stack, MySQL, AWS S3, Tailwind and Docker.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            contentArrowStyle={{ borderRight: '7px solid white' }}
            date="2024 - 2025"
            iconStyle={{ background: '#5000ca', color: 'white' }}
            icon={<FontAwesomeIcon icon={faLaptopCode} />}
          >
            <h3 className="vertical-timeline-element-title">FullStack Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">MACS-G Mumbai, IN</h4>
            <p>
              Full-stack Web Development with MERN Stack, MySQL, AWS S3, GCP Storage, Next.js, GraphQL, and Docker.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            contentArrowStyle={{ borderRight: '7px solid white' }}
            date="2022 - 2024"
            iconStyle={{ background: '#5000ca', color: 'white' }}
            icon={<FontAwesomeIcon icon={faProjectDiagram} />}
          >
            <h3 className="vertical-timeline-element-title">Associate Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Metricoid Technology Mumbai, IN</h4>
            <p>
              Frontend Development, Backend Development, User Experience, Team Leading, Desktop Application, AWS, GCP, Peer to Peer.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
